
import { useEffect } from 'react';
import { toast } from 'sonner';

interface DashboardInitializerProps {
  hasLoadedFromState: boolean;
  setHasLoadedFromState: (loaded: boolean) => void;
  location: any;
  handleSubmit: (url: string) => void;
  scrollToSection: (sectionId: string) => void;
}

const DashboardInitializer: React.FC<DashboardInitializerProps> = ({
  hasLoadedFromState,
  setHasLoadedFromState,
  location,
  handleSubmit,
  scrollToSection
}) => {
  useEffect(() => {
    console.log("Dashboard: Initializing with location state:", location.state);
    
    const hash = window.location.hash.substring(1);
    
    if (hash) {
      scrollToSection(hash);
    }
    
    // This ensures we only process state once during initialization
    if (!hasLoadedFromState) {
      setHasLoadedFromState(true);
      
      // Check location state to determine if we should preserve results
      const state = location.state as { 
        url?: string; 
        startAnalysis?: boolean; 
        preserveResults?: boolean; 
        fromAdmin?: boolean;
        fromHeader?: boolean;
        initialSection?: string;
      } | null;
      
      console.log("Dashboard: Processing location state:", state);
      
      if (state?.preserveResults) {
        console.log("Dashboard: preserveResults flag is true, keeping current results");
        
        // If coming from admin, navigate to results section
        if (state.fromAdmin || state.fromHeader) {
          scrollToSection("dashboard");
        }
        
        // If initialSection is provided, navigate to that section
        if (state.initialSection) {
          scrollToSection(state.initialSection);
        }
      } 
      // If URL and startAnalysis are provided, start a new analysis
      else if (state?.url && state?.startAnalysis) {
        console.log("Dashboard: Starting new analysis for URL:", state.url);
        handleSubmit(state.url);
      }
      
      // Clear the state from the history to prevent it from being reapplied
      window.history.replaceState({}, document.title);
    }
  }, [
    location.state, 
    hasLoadedFromState, 
    handleSubmit, 
    setHasLoadedFromState,
    scrollToSection
  ]);
  
  return null;
};

export default DashboardInitializer;
